// @ts-strict-ignore
import { Directive, HostListener, Input } from '@angular/core';
import { UserActionsLoggingManager } from './user-actions-logging.manager';

@Directive({
  selector: '[appActionLogId]',
})
export class ActionLogDirective {
  @Input() appActionLogId: string = null;
  @Input() appActionLogParam: string | boolean = null;

  constructor(private userActionsLoggingManager: UserActionsLoggingManager) {}

  @HostListener('click')
  onClick() {
    if(!this.appActionLogId) return;
    this.userActionsLoggingManager.logFunction(this.appActionLogId, this.appActionLogParam);
  }
}
